import { each } from 'lodash';
import SegmentAnalytics from '@segment/analytics.js-core/build/analytics';
import UrlPattern from 'url-pattern';
import config from '../../../config';

import { getShopBrandId } from '../../shops/selectors';

import { store } from '../../../root';

const getBrandId = () => {
  try {
    // Match the url pattern to pull current shop route, as we're outside router
    const pattern = new UrlPattern(`${config.urlPatterns.booking}/*`);

    const match = pattern.match(window.location.pathname);
    const shopRoute = match.shopRoute;

    const state = store.getState();
    const brandId = getShopBrandId(state, shopRoute);

    return brandId;
  } catch (e) {
    return null;
  }
};

export default class Analytics {
  constructor(integrations = {}) {
    this.engine = new SegmentAnalytics();
    this.useSampling = process.env.WEB_ENV === 'production';

    // Math.random() has uniform distribution, so theres no need to
    // deal with Gaussian bell intricacies: https://tc39.es/ecma262/#sec-math.random

    // We're looking at 5% of visitors
    this.isInSampledPercentile = Math.random() >= 0.95;

    each(integrations, Integration => this.engine.use(Integration));

    this.engine.initialize(config.analytics);
  }

  fireEvent(event, customOptions = null) {
    if (this.useSampling && !this.isInSampledPercentile) {
      return false;
    }

    const options = customOptions || {};

    const traits = {
      platform: 'web',
      brandId: getBrandId(),
      ...options,
    };

    this.engine.track(event, traits);
    return true;
  }

  trackPageview(name) {
    if (this.useSampling && !this.isInSampledPercentile) {
      return false;
    }

    const traits = {
      platform: 'web',
      brandId: getBrandId(),
      name,
    };

    // Mixpanel doesn't support Page events, so we're adding custom ones
    this.engine.track('Pageview', traits);
    return true;
  }

  identify(id, traits = {}) {
    if (this.useSampling && !this.isInSampledPercentile) {
      return;
    }

    this.engine.identify(id, {
      platform: 'web',
      ...traits,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/Analytics.js